import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';


function valuetext(value) {
  return `${value}%`;
}

export default function DiscreteSlider(props) {
  const changeFunc = props.onChange
  const value = props.value
  return (
    <Box >
      <Slider
        onChange={changeFunc}
        defaultValue={25}
        getAriaValueText={valuetext}
        valueLabelFormat={valuetext}
        valueLabelDisplay="auto"
        value={value}
        // shiftStep={10}
        // marks
        // step={25}
        min={0}
        max={100}
      />
    </Box>
  );
}
